import Vue from 'vue'
import Router from 'vue-router'

import HomePage from '@/pages/homepage'
import About from '@/pages/about/about'
import AboutCorner from '@/pages/about/about_corner'
import AboutEnv from '@/pages/about/about_env'
import AboutInfo from '@/pages/about/about_info'
import AboutReport from '@/pages/about/about_report'

import EventContent from '@/components/event_split2_content'
import EventList from '@/pages/event/event_list'
import EventNews from '@/pages/event/event_news'
import NewsContent from '@/components/news_content'

import ProgramContent from '@/components/artist_split2_content'
import ProgramContent2 from '@/components/artist_split2_content2'
import ProgramList from '@/pages/program/program_list'
import ProgramApply from '@/pages/program/program_apply'
import ProgramActivities from '@/pages/program/program_activities'
import ProgramActivityOther1 from '@/pages/program/program_activity_other_1'


import ReservationSecret from '@/pages/reservation/reservation_secret'
import ReservationPlay from '@/pages/reservation/reservation_play'

import Rent from '@/pages/rent/rent'

import SupportClub from '@/pages/support/support_club'
import SupportTeam from '@/pages/support/support_team'

Vue.use(Router)

export default new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [{
    path: '/',
    component: HomePage
  }, {
    path: '/about',
    component: About
  }, {
    path: '/about/corner',
    component: AboutCorner
  }, {
    path: '/about/environment',
    component: AboutEnv
  }, {
    path: '/about/report',
    component: AboutReport
  }, {
    redirect: "/",
    path: '/about/info',
    component: AboutInfo
  }, {
    path: '/event/list',
    component: EventList
  }, {
    path: '/event/news',
    component: EventNews
  }, {
    path: '/event/:id',
    component: EventContent
  }, {
    path: '/news/:id',
    component: NewsContent
  }, {
    path: '/program/list',
    component: ProgramList
  },
	{
    path: '/program/content/:id',
    component: ProgramContent2
  },
	{
    path: '/program/activities',
    component: ProgramActivities
  },{
    path: '/program/activities/1',
    component: ProgramActivityOther1
  }, {
    path: '/program/apply',
    component: ProgramApply
  }, {
    path: '/program/:id',
    component: ProgramContent
  }, {
    path: '/reservation/secret',
    component: ReservationSecret
  }, {
    path: '/reservation/play',
    component: ReservationPlay
  }, {
    path: '/rent',
    component: Rent
  }, {
    path: '/support/team',
    component: SupportClub
  }, {
    path: '/support/club',
    component: SupportTeam
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js